<svg
  (click)="toggle()"
  [class.active]="isActive"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 100 100"
  style="cursor: pointer"
>
  <line class="line line1" [ngStyle]="styles" x1="30" y1="35" x2="70" y2="35" />
  <line class="line line2" [ngStyle]="styles" x1="30" y1="50" x2="70" y2="50" />
  <line class="line line3" [ngStyle]="styles" x1="30" y1="65" x2="70" y2="65" />
</svg>
